<template>
  <div
    class="tw-flex tw-h-screen tw-w-screen tw-justify-center tw-items-center"
  >
    <div class="tw--mt-10">
      <div class="tw-text-center tw-py-2">
        <svg
          fill="none"
          class="tw-w-16 tw-h-16 tw-mx-auto tw-animate-spin tw-text-gray-300"
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            clip-rule="evenodd"
            d="M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z"
            fill="currentColor"
            fill-rule="evenodd"
          />
        </svg>
      </div>
      <div class="tw-p-0 tw-text-gray-700 tw-text-lg tw-text-center">
        Inicializando o totem...
      </div>
    </div>
  </div>
</template>

<script>
import { auth, db, loadPrecos } from "@/service/firebase";
import {
  iniciarListenerTotemEmTempoReal,
  pararListenerTotemEmTempoReal,
} from "@/service/totemRealtime";
import {
  manutencaoEfetiva,
  temCamadaManutencao,
  temConfiguracaoTotem,
  temConfiguracaoFormatos,
} from "@/service/totemOperation";
import { doc, getDoc, serverTimestamp, updateDoc } from "@firebase/firestore";
import { onAuthStateChanged, signInWithEmailAndPassword } from "firebase/auth";

// Aguarda o Firebase restaurar a sessão persistida antes de agir
function aguardaEstadoAuth() {
  return new Promise((resolve) => {
    const cancelar = onAuthStateChanged(auth, (user) => {
      cancelar();
      resolve(user);
    });
  });
}

export default {
  async beforeMount() {
    try {
      // Usa sessão já existente (localStorage) ou autentica com conta de serviço
      const user = await aguardaEstadoAuth();
      if (!user) {
        await signInWithEmailAndPassword(
          auth,
          process.env.VUE_APP_TOTEM_EMAIL,
          process.env.VUE_APP_TOTEM_PASS
        );
      }
      await this.validaExistenciaDoID();
    } catch (err) {
      console.error("Erro na inicialização do totem:", err);
      this.$router.push("/404");
    }
  },
  methods: {
    async validaExistenciaDoID() {
      const parametroID = this.$route.params.id;
      if (!parametroID) {
        this.$router.push("/404");
        return;
      }
      pararListenerTotemEmTempoReal();
      localStorage.setItem("totemId", parametroID);
      const referencia = doc(db, "totem", parametroID);
      const docSnap = await getDoc(referencia);
      if (docSnap.exists()) {
        await this.carregaTotem();
      } else {
        localStorage.removeItem("totemId");
        this.$router.push("/404");
      }
    },
    async carregaTotem() {
      const tokenParam = this.$route.params.id;
      const docRef = doc(db, "totem", tokenParam);
      const docSnap = await getDoc(docRef);
      const payload = docSnap.data();
      this.$store.commit("totem/setToken", tokenParam);
      if (payload) this.$store.commit("totem/setTotem", payload);
      // O card de versão do Gestão deve refletir o build que de fato iniciou
      // neste equipamento, não a última versão publicada no repositório.
      // Uma falha de telemetria não impede a cabine de funcionar.
      updateDoc(docRef, {
        versaoApp: process.env.VUE_APP_VERSION,
        versaoAppInformadaEm: serverTimestamp(),
        recursosApp: { manutencaoSemFormato: 1 },
        recursosAppInformadosEm: serverTimestamp(),
      }).catch((error) => {
        console.warn("Falha ao informar a versão instalada do totem:", error);
      });
      iniciarListenerTotemEmTempoReal(tokenParam, {
        store: this.$store,
        router: this.$router,
      });
      // O listener precisa existir também na tela de configuração inválida:
      // se o Gestão ligar a manutenção nesse estado, o Totem deve reagir sem
      // depender de reload ou de voltar à Home.
      if (!this.verificaConfig(payload)) {
        this.$router.push("/error-config");
        return;
      }
      loadPrecos();
      this.ParaHomeTotem(payload);
    },
    verificaConfig(bin) {
      if (!temConfiguracaoTotem(bin)) {
        this.$root.errorConfig("Configuração do totem não encontrada", false);
        return false;
      }
      // Configuração incompleta continua sendo um erro legítimo; já uma
      // desativação/ocultação conhecida de todos os formatos é manutenção.
      if (bin.config.manutencao === true || temCamadaManutencao(bin))
        return true;
      if (!temConfiguracaoFormatos(bin)) {
        this.$root.errorConfig(
          "Configuração dos formatos de impressão não encontrada",
          false
        );
        return false;
      }
      return true;
    },
    ParaHomeTotem(payload) {
      const destino = manutencaoEfetiva(payload)
        ? "/manutencao"
        : "/cabine/home";
      this.$router.replace(destino);
    },
  },
};
</script>
